<template>
	<div class='block-main-url'>
    <p v-if='mainBlockIsHearing' class='block-main-url'>
      {{hearing.CommitteeName}} {{textHasHearingInCase}}: <a :href='hearing.ProceedingLinkUrl' :title='hearing.ProceedingTitle'>{{hearing.ProceedingTitle}}</a>
    </p>
    <p v-else class='block-main-url'>
      {{textCaseNr}} {{agenda.OrderNumber}}: <a :href='agenda.LinkUrl' :title='agenda.TitleText'>{{agenda.TitleText}}</a>
    </p>
  </div>
</template>

<script>
import lang from '../../lang'
import mixins from '../../mixins'

export default {
  mixins: [mixins],
  name: 'top-text-box-main-url',
  data () {
    return {
      hearing: {},
      agenda: {},
      textHasHearingInCase: lang.hasHearingInCase[this.$root.cmsData.lang],
      textCaseNr: lang.caseNr[this.$root.cmsData.lang]
    }
  },
  computed: {
    mainBlockIsHearing: function () {
      return this.liveHelper().mainBlockIsHearing(this.$root.cmsData)
    }
  },
  created () {
    if (this.mainBlockIsHearing) {
      this.hearing = this.liveHelper().activeHearing(this.$root.cmsData, this.$root.liveData)
    } else {
      this.agenda = this.liveHelper().agendaItem(this.$root.liveData)
    }
  }
}
</script>



// WEBPACK FOOTER //
// TopTextBoxMainUrl.vue?68959483